import { getEventTree } from '@/api/independentViews/track/statisticsDashboard'
import { loopNode } from '@/utils'

const state = {
  eventList: [], // 事件列表数据
  eventListTimestamp: 0, // 事件列表获取时间戳
  eventListNoCache: false, // 事件列表无缓存标记
}

const getters = {
  eventList: (state) => state.eventList,
  eventListTimestamp: (state) => state.eventListTimestamp,
  eventListNoCache: (state) => state.eventListNoCache,
}

const mutations = {
  SET_EVENT_LIST: (state, eventList) => {
    state.eventList = eventList
  },
  SET_EVENT_LIST_TIMESTAMP: (state, timestamp) => {
    state.eventListTimestamp = timestamp
  },
  SET_EVENT_LIST_NO_CACHE: (state, eventListNoCache) => {
    state.eventListNoCache = eventListNoCache
  },
}

const actions = {
  // 获取事件列表
  async getEventList({ state, commit }, extra = {}) {
    const noCache = state.eventListNoCache || extra.noCache || false

    // 检查缓存是否有效：有数据 && 不强制刷新 && 时间未超过1分钟
    if (!noCache && state.eventList && state.eventList.length > 0) {
      const curTime = new Date().getTime()
      const fiveMinutes = 60 * 1000 //1分钟的毫秒数
      const isWithinTimeLimit = curTime - state.eventListTimestamp < fiveMinutes

      if (isWithinTimeLimit) {
        return state.eventList
      }
    }

    try {
      const ret = await getEventTree()
      if (ret.code == 0 && ret.data) {
        const retData = ret.data.list || {}
        const listData = [
          {
            event_type: 'top_level',
            token: 'top_page',
            id: '-1',
            show_name: '页面维度',
            children: retData.pages || [],
          },
          {
            event_type: 'top_level',
            token: 'top_public_event',
            id: '-2',
            show_name: '公共事件',
            children: retData.public_events || [],
          },
        ]

        loopNode(
          listData,
          (item, index, arr, extra) => {
            // 使用token组合路径唯一标识
            item.id = item.token
            item.key = [extra.pid, item.id].filter(Boolean).join('||') //避免重复，将路径作为唯一标识
            arr.splice(index, 1, item)
          },
          'children',
          null,
          { pidSplit: '||' }
        )

        const curTime = new Date().getTime()
        commit('SET_EVENT_LIST', listData)
        commit('SET_EVENT_LIST_TIMESTAMP', curTime)
        commit('SET_EVENT_LIST_NO_CACHE', false)

        return listData
      }
      return []
    } catch (err) {
      console.error('获取事件列表失败:', err)
      return []
    }
  },

  // 设置事件列表无缓存标记
  setEventListNoCache({ commit }, eventListNoCache) {
    commit('SET_EVENT_LIST_NO_CACHE', eventListNoCache)
  },
}

export default { state, getters, mutations, actions }
